import { RouteType } from 'types/RouteType';

const qualityControlRoute: RouteType = {
  name: 'Quality Control',
  path: '/job/:jobNumber/quality-control',
  layout: '/app',
  viewportCard: {
    header: {
      title: 'Quality Control',
      component: () => import('./QualityControl.Header'),
      enableToolbox: true,
      enableBackButton: true,
      enableRefreshButton: true,
    },
    body: {
      component: () => import('./QualityControl.Body'),
      gridContainer: {
        namespace: 'precast-qc-grid',
        storeName: 'qualityControlStore',
        customEntity: 'filteredItems',
        columnHeaders: [
          {
            key: 'elementId',
            title: 'Product ID',
            width: 120,
          },
          {
            key: 'elementType',
            title: 'Product Type',
            width: 150,
          },
          {
            key: 'productionDate',
            title: 'Prod. Date',
            dataType: 'date',
            width: 120,
          },
          {
            key: 'inspectionDate',
            title: 'Insp. Date',
            dataType: 'date',
            width: 120,
          },
          {
            key: 'inspector',
            title: 'Inspector',
            width: 150,
          },
          {
            key: 'status',
            title: 'Status',
            width: 120,
          },
          {
            key: 'dimensionCheck',
            title: 'Dims OK?',
            dataType: 'boolean',
            width: 80,
          },
          {
            key: 'reinforcementCheck',
            title: 'Reinf. OK?',
            dataType: 'boolean',
            width: 80,
          },
          {
            key: 'surfaceFinishCheck',
            title: 'Finish OK?',
            dataType: 'boolean',
            width: 80,
          },
        ],
        defaultSort: {
          sortBy: ['productionDate'],
          sortDirection: { productionDate: 'DESC' },
        },
      },
    },
  },
  group: 'Quality Control',
  requiresAuth: false,
  requiresPermission: false,
  permissionPath: '/app/quality-control',
  channels: ['quality-control/:jobNumber'],
  // enableAutoFind: true,
  projectRoute: true,
};

export default qualityControlRoute;
